export default {
	langName: 'eng',
	wordings: {
		ROOMID: "Room ID",
		PASSWORD: "Password",
		DURATION: "Duration",
		PARTICIPANTS: "Participants",
		SCREEN_RECORDING: "屏幕分享及錄影中 Screen Sharing and Recording",


		//title
		CO_BROWSE_ROOM_MONITORING: "Co-browse Room Monitoring",
		CO_BROWSE_ROOM_HISTORY: "Co-browse Room History",
		CO_BROWSE_ROOM_CREATE_TITLE: "Your room has been created",
		CO_BROWSE_ROOM_CREATE_SUBTITLE:"subtitle",
		//label
		CO_BROWSE_ROOM_CODE: "Room Code",
		CO_BROWSE_ROOM_PASSWORD: "Room Password",
		CO_BROWSE_ROOM_DURATION:"Duration",
		CO_BROWSE_ROOM_PARTICIPANTS:"Participants",
		CO_BROWSE_ROOM_AGENT_NAME:"Agent Name",
		CO_BROWSE_ROOM_AGENT_STATUS:"Agent Status",
		CO_BROWSE_ROOM_CUSTOMER_NAME:"Customer Name",
		CO_BROWSE_ROOM_CUSTOMER_STATUS:"Customer Status",
		CO_BROWSE_ROOM_NAME: "Room Name",
		CO_BROWSE_ROOM_START_DATETIME: "Start Time",
		CO_BROWSE_ROOM_END_DATETIME: "End Time",
		CO_BROWSE_ROOM_STATUS: "Status",
		CO_BROWSE_ROOM_VIEW_DETAIL: "View Detail",
		//btn
		CO_BROWSE_ROOM_BUTTON_CREATE: "Create",
		CO_BROWSE_ROOM_BUTTON_CANCEL: "Cancel",
		CO_BROWSE_ROOM_BUTTON_CONFIRM: "Confirm",
		CO_BROWSE_ROOM_BUTTON_DISMISS: "Dismiss",
		CO_BROWSE_ROOM_BUTTON_SEND: "Send",
		CO_BROWSE_ROOM_BUTTON_REJOIN: "Rejoin",
		CO_BROWSE_ROOM_BUTTON_RESEND: "Resend",
		CO_BROWSE_ROOM_BUTTON_JOIN: "Join",

		//Message
		CO_BROWSE_ROOM_CLOSE_MSG: "Close automatically after 10 minutes",
		CO_BROWSE_ROOM_CONFIRM_DISMISS_MSG: "Confirm to dismiss the room?",
		CO_BROWSE_ROOM_CONFIRM_CREATE_MSG: "Confirm to create the room?",
		
	}
}
